import {
    JOB_CONFIG_JOB_TYPES_FETCH,
    JOB_CONFIG_FAVOURITE_JOBS_FETCH,
    JOB_ADS_ADD_TO_FAVOURITE,
    JOB_ADS_REMOVE_FROM_FAVOURITE
} from '../actions/constants'

const defaultState = {
    jobTypes: [],
    favouriteJobAds: []
};

export default (state = defaultState, action) => {
    switch (action.type){
        case JOB_CONFIG_JOB_TYPES_FETCH:
            return {
                ...state,
                jobTypes: action.payload
            };
        case JOB_CONFIG_FAVOURITE_JOBS_FETCH:
            return {
                ...state,
                favouriteJobAds: action.payload
            }
        case JOB_ADS_ADD_TO_FAVOURITE:
            return {
                ...state,
                favouriteJobAds: state.favouriteJobAds.concat(action.payload.id)
            }
        case JOB_ADS_REMOVE_FROM_FAVOURITE:
            return {
                ...state,
                favouriteJobAds: state.favouriteJobAds.filter((el) => !action.payload.id.includes(el))
            }
        default:
            return state;
    }
};